import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '../../components/ui/Card';
const completedCourses = [{
  name: 'Ethics & The Rules (with NAR Code of Ethics)',
  creditType: '3 hrs. Comm. Standards',
  dateCompleted: '02/12/2025'
}];
export function ClassHistory() {
  return <div className="space-y-4" data-id="element-1959">
      {/* Inserted a styled header section with background color, heading, and description */}
      <div className="rounded-xl px-6 py-5 text-white" style={{
      backgroundColor: '#4A2D8F'
    }} data-id="element-1960">
        <h1 className="text-2xl font-extrabold tracking-tight mb-1" data-id="element-1961">
          Class History
        </h1>
        <p className="text-purple-200 text-sm" data-id="element-1962">
          View your completed courses and download certificates to save or
          print.
        </p>
      </div>

      <div data-id="element-1963">
        <button className="text-blue-600 hover:underline text-sm font-medium uppercase tracking-wide" data-id="element-1964">
          CE CREDITS TRACKER
        </button>
        <span className="ml-1 inline-flex items-center justify-center w-4 h-4 rounded-full bg-blue-500 text-white text-xs font-bold" data-id="element-1965">
          ?
        </span>
      </div>

      <p className="text-xs text-slate-600" data-id="element-1966">
        *You will need Adobe Reader installed on your computer to print the
        certificate.{' '}
        <button className="text-blue-600 hover:underline" data-id="element-1967">Click here</button> to
        download the free reader.*
      </p>

      <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-1968">
        <div className="overflow-x-auto" data-id="element-1969">
          <table className="w-full text-sm text-left" data-id="element-1970">
            <thead style={{
            backgroundColor: '#4A2D8F'
          }} className="text-white font-medium" data-id="element-1971">
              <tr data-id="element-1972">
                <th className="px-4 py-3 border-r border-purple-700" data-id="element-1973">Class</th>
                <th className="px-4 py-3 border-r border-purple-700 w-40 text-center" data-id="element-1974">
                  Credit Type
                </th>
                <th className="px-4 py-3 border-r border-purple-700 w-32 text-center" data-id="element-1975">
                  Date Completed
                </th>
                <th className="px-4 py-3 border-r border-purple-700 w-28 text-center" data-id="element-1976">
                  Print Certificate
                </th>
                <th className="px-4 py-3 w-28 text-center" data-id="element-1977">Review Class</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-1978">
              {completedCourses.map((course, i) => <tr key={i} className="hover:bg-purple-50/20" data-id="element-1979">
                  <td className="px-4 py-2.5 border-r border-slate-200 text-slate-800" data-id="element-1980">
                    {course.name}
                  </td>
                  <td className="px-4 py-2.5 border-r border-slate-200 text-center text-slate-700" data-id="element-1981">
                    {course.creditType}
                  </td>
                  <td className="px-4 py-2.5 border-r border-slate-200 text-center text-slate-700" data-id="element-1982">
                    {course.dateCompleted}
                  </td>
                  <td className="px-4 py-2.5 border-r border-slate-200 text-center" data-id="element-1983">
                    <button className="text-blue-600 hover:underline text-sm" data-id="element-1984">
                      Print Certificate
                    </button>
                  </td>
                  <td className="px-4 py-2.5 text-center" data-id="element-1985">
                    <Link to={`/student/class/${course.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')}/content`} className="text-blue-600 hover:underline text-sm" data-id="element-1986">
                      Review Class
                    </Link>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
}